import { NOTIFICATION_KEYS } from "@/enums/notifications";
import { LOCATION_IMPORT_STATUS } from "@/enums/gmb-locations-import";
import { LOCAL_STORAGE_KEYS } from "@/enums/local-storage";

export const hasNotification = key => {
  if (key === NOTIFICATION_KEYS.LOCATIONS_IMPORT_PENDING) {
    return (
      localStorage.getItem(LOCAL_STORAGE_KEYS.LOCATIONS_IMPORT_STATUS) ===
      `${LOCATION_IMPORT_STATUS.PENDING}`
    );
  }
  return false;
};
